export function useMediaLocalization() {
  const { locale } = useI18n();

  function getMediaLocaleUrl(fileName: string, path = 'video'): string {
    switch (locale.value) {
      case 'es':
        return `/${path}/es/ES_${fileName}`;
      case 'es-mx':
        return `/${path}/mx/MX_${fileName}`;
      case 'de':
        return `/${path}/de/DE_${fileName}`;
      case 'pt':
        return `/${path}/pt/PT_${fileName}`;
      case 'pt-br':
        return `/${path}/br/BR_${fileName}`;
      case 'fr':
        return `/${path}/fr/FR_${fileName}`;
      case 'it':
        return `/${path}/it/IT_${fileName}`;
      case 'en':
      default:
        return `/${path}/en/EN_${fileName}`;
    }
  }

  return {
    getMediaLocaleUrl,
  };
}
